export default "__VITE_ASSET__Ca45eCtO__"